/**
 * ATTENTION! This file is auto-generated for the 'core' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { EntityTypeRepository } from '../server/repositories/EntityTypeRepository';
import type { ModuleRepository } from '../server/repositories/ModuleRepository';
import type { OptionRepository } from '../server/repositories/OptionRepository';
import type { RepositoryRepository } from '../server/repositories/RepositoryRepository';
import type { RepositoryActionRepository } from '../server/repositories/RepositoryActionRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type EntityTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<EntityTypeRepository>;
export function useEntityTypeRepository(): EntityTypeRepositoryClient { return makeRepositoryProxy<EntityTypeRepositoryClient>('core::EntityTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useEntityTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const entityTypeRepository = useEntityTypeRepository();

type ModuleRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ModuleRepository>;
export function useModuleRepository(): ModuleRepositoryClient { return makeRepositoryProxy<ModuleRepositoryClient>('core::ModuleRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useModuleRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const moduleRepository = useModuleRepository();

type OptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<OptionRepository>;
export function useOptionRepository(): OptionRepositoryClient { return makeRepositoryProxy<OptionRepositoryClient>('core::OptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useOptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const optionRepository = useOptionRepository();

type RepositoryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RepositoryRepository>;
export function useRepositoryRepository(): RepositoryRepositoryClient { return makeRepositoryProxy<RepositoryRepositoryClient>('core::RepositoryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRepositoryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const repositoryRepository = useRepositoryRepository();

type RepositoryActionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RepositoryActionRepository>;
export function useRepositoryActionRepository(): RepositoryActionRepositoryClient { return makeRepositoryProxy<RepositoryActionRepositoryClient>('core::RepositoryActionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRepositoryActionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const repositoryActionRepository = useRepositoryActionRepository();

type reloadOptionsType = typeof import('../server/functions/reloadOptions').reloadOptions;
export const reloadOptions: RpcFunctionClient<reloadOptionsType> = makeFunctionProxy<reloadOptionsType>('core::reloadOptions');

type getSystemMetricsType = typeof import('../server/functions/getSystemMetrics').getSystemMetrics;
export const getSystemMetrics: RpcFunctionClient<getSystemMetricsType> = makeFunctionProxy<getSystemMetricsType>('core::getSystemMetrics');

type enqueueTaskType = typeof import('../server/functions/enqueueTask').enqueueTask;
export const enqueueTask: RpcFunctionClient<enqueueTaskType> = makeFunctionProxy<enqueueTaskType>('core::enqueueTask');
